<template>
  <main :class="dynamic_row ? 'row' : ''">
    <div :class="dynamic_class ? 'col-md-10' : ''">
      <div class="mt-5 pl-0 pr-0">
        <Category />
      </div>
      <div class="container">
        <div v-if="loading" class="text-center">
          <sweetalert-icon class="text-center" :icon="loadingType" />
          {{ loadingMessage }}
        </div>
        <div class="row pt-4 pb-4" v-else>
          <h3 class="category-name text-center col-md-12 m-4">
            {{ getCartName() }}
          </h3>
          <div v-if="loading" class="text-center col-sm-12">
            <sweetalert-icon class="text-center" :icon="loadingType" />
            {{ loadingMessage }}
          </div>
          <div
            v-for="order in starting"
            :key="order.id"
            class="col-sm-3"
            v-else
          >
            <div class="card mt-3 p-3">
              <img
                class="card-img-top mt-3"
                style="height: auto; width: 100%;"
                :src="getProduct(order.productsId, 'image')"
                :alt="getProduct(order.productsId, 'name') + ' AamCart.com'"
              />
            </div>
            <div class="product-other text-center">
              <h3 class="name">
                {{ getProduct(order.productsId, "name") }}
              </h3>
              <span class="mb-2">
                Sold By
                <router-link :to="'/vendorProfile/' + order.vendorId">{{
                  getSellerName(order.vendorId)
                }}</router-link>
              </span>
              <h3 class="price">₹ {{ order.sellPrice }}</h3>
              <span class="cart-add" v-if="order.stock > 1">
                <i
                  class="btn btn-sm btn-circle fa fa-minus"
                  style="background-color:#D0D0D2; color:#1A1824;"
                  @click="
                    addToCart(
                      order.id,
                      order.productsId,
                      getCart(order.id, 'qty', getDataCart),
                      getProduct(order.productsId, 'unitType'),
                      order.sellPrice,
                      'minus',
                      user.uid,
                      order.vendorId
                    )
                  "
                  v-if="user"
                ></i>
                <span v-else>
                  <router-link to="/login">
                    <i
                      class="btn btn-sm btn-circle fa fa-minus"
                      style="background-color:#D0D0D2; color:#1A1824
                          "
                    ></i>
                  </router-link>
                </span>
                <span style="padding:5px;">
                  {{ getCart(order.id, "qty", getDataCart) }}
                  {{ getProduct(order.productsId, "unitType") }}
                </span>
                <i
                  class="btn btn-sm btn-circle fa fa-plus"
                  style="background-color:#51381b ; color:#FFFFFF;"
                  v-if="user"
                  @click="
                    addToCart(
                      order.id,
                      order.productsId,
                      getCart(order.id, 'qty', getDataCart),
                      getProduct(order.productsId, 'unitType'),
                      order.sellPrice,
                      'plus',
                      user.uid,
                      order.vendorId
                    )
                  "
                ></i>
                <span v-else>
                  <router-link to="/login">
                    <i
                      class="btn btn-sm btn-circle fa fa-plus"
                      style="background-color:#51381b ; color:#FFFFFF;"
                    ></i>
                  </router-link>
                </span>
              </span>
              <span v-else>
                <h3 style="font-size:16px" class="text-danger">
                  Out of Stock
                </h3>
              </span>
            </div>
          </div>
          <div class="pt-5" style="padding-top:100px;"></div>
          <div class="mybutton" v-if="starting.length != vendorProducts.length">
            <button
              type="button"
              class="btn btn-success"
              v-on:click="fetchmore"
            >
              Show More...
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-2 media-query"
      v-if="user"
      style="background-color:#E7E7E7"
    >
      <Cart />
    </div>
  </main>
</template>

<script>
import { dbFs, db } from "@/modules/database";
import Cart from "@/components/Cart.vue";
import { mapGetters } from "vuex";
import { getCart, addToCart } from "@/modules/cart";
import Category from "../components/Category";
export default {
  data: () => {
    return {
      index: 15,
      cart: 0,
      loading: false,
      vendors: [],
      loadingType: "loading",
      loadingMessage: "Uploading",
      category: [],
      vendorProducts: [],
      starting: [],
      products: [],
      carts: [],
      dynamic_class: false,
      class: "col-md-8",
      dynamic_row: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      getDataCart: "getDataCart"
    })
  },
  components: {
    Cart,
    Category
  },
  mounted() {
    this.getfirst();
    this.AddDynamicClass();
    this.setupFirebaseReading();
    this.getAllVendor();
  },
  methods: {
    getfirst: function() {
      this.loading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Product Loading";
      this.$bind(
        "starting",
        dbFs
          .collection("vendorProducts")
          .where("productCategoryId", "==", this.$route.params.catId)
          .where("status", "==", true)
          .limit(16)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllVendor() {
      this.$bind("vendors", dbFs.collection("vendor")).catch(error => {
        console.log(error);
      });
    },
    getSellerName(id) {
      let seller = "";
      for (const cusKey of Object.keys(this.vendors)) {
        const product = this.vendors[cusKey];
        if (id == product.id) {
          seller = product.shopDetails.name;
        }
      }
      return seller;
    },
    fetchmore() {
      console.log("Fetchmore");
      var start = this.index + 1;
      var end = start + 12;
      for (start; start < end; start++) {
        if (this.vendorProducts[start]) {
          this.starting.push(this.vendorProducts[start]);
        }
      }
      this.index = end - 1;
    },
    setupFirebaseReading: function() {
      this.loading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Product Loading";
      this.$bind(
        "vendorProducts",
        dbFs
          .collection("vendorProducts")
          .where("productCategoryId", "==", this.$route.params.catId)
          .where("status", "==", true)
      )
        .then(() => {
          this.getProductsData();
          this.getCategoryData();
          this.getCartData();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    AddDynamicClass() {
      if (this.user) {
        this.dynamic_class = "col-md-10";
        this.dynamic_row = "row";
      } else {
        this.dynamic_class = "";
        this.dynamic_row = "";
      }
    },
    getProductsData() {
      this.loading = true;
      this.vendorProducts.forEach(doc => {
        dbFs
          .collection("products")
          .where("productId", "==", doc.productsId)
          .limit(1)
          .get()
          .then(res => {
            res.forEach(innerdoc => {
              var obj = {
                id: innerdoc.id,
                name: innerdoc.data().name,
                image: innerdoc.data().image,
                productId: innerdoc.data().productId,
                unitType: innerdoc.data().unitType
              };
              this.products.push(obj);
            });
          });
      });
    },
    getCategoryData() {
      this.loading = true;
      this.$bind(
        "category",
        dbFs
          .collection("productCategory")
          .where("categoryId", "==", this.$route.params.catId)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCartName() {
      let name = "";
      if (this.category.length > 0) {
        name = this.category[0].name;
      }
      return name;
    },
    getCartData() {
      this.loading = true;
      this.$rtdbBind("carts", db.ref("carts/" + this.user.uid))
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.loadingError = true;
        });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getCart,
    addToCart
  },
  watch: {
    user() {
      this.dynamic_class = !this.dynamic_class;
      this.dynamic_row = !this.dynamic_row;
    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
.mybutton {
  margin-top: 50px;
  width: 100%;
  text-align: center;
}
.slide-bar-view {
  margin-left: 130px;
  margin-right: 130px;
}
.add-to-cart {
  padding-top: 15px;
  padding-bottom: 20px;
}
.add-to-cart button {
  width: 120px;
  height: 42px;
  border-radius: 33px;
}
.cart-add {
  font-size: 15px;
  color: #000000;
}
.product-other .name {
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}
.product-other .price {
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 1.2px;
  color: #51381b;
}
.product-other {
  padding-top: 15px;
}
.product-images {
  width: 215px;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 0px;
}
.product-images img {
  margin: auto;
}
.product-box {
  border-radius: 0px !important;
  padding-top: 20px;
  width: 215px;
}
.btn-for-box {
  width: 257px;
  height: 85px;
  background-color: #1c1a1a;
  opacity: 0.8;
  border-radius: 33px;
  backdrop-filter: blur(9px);
}
.btn-for-box h4 {
  font-size: 22px;
  font-family: "Pacifico", cursive;
  color: #ffffff;
  letter-spacing: 2.88px;
  padding-top: 15px;
  text-align: center;
}
.btn-for-box p {
  font-size: 16px;
  font-family: "Montserrat-Regular";
  color: #ffffff;
  letter-spacing: 0.51px;
  /* padding-top: 5px; */
  text-align: center;
}
.category-wise-item {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
}
.category-name {
  font-size: 34px;
  font-family: "Montserrat-Regular";
  color: #313131;
  font-weight: bold;
}
.category-list {
  margin-left: 20px;
  margin-right: 20px;
}
.categoryImage {
  width: 376px;
  height: 242px;
}
.category {
  margin-left: 15px;
  margin-right: 15px;
}
.category-box-1 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/1.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-2 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/2.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-3 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/3.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-4 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/4.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-inside:hover {
  background-color: #51381b;
  opacity: 0.9;
  margin: auto;
}
.category-box-inside {
  height: 100%;
  /* margin: auto; */
  padding-top: 25%;
  padding-left: 45px;
  padding-right: 25%;
  /* padding-bottom: 76px; */
}
.primary-color {
  color: #17aa18;
}
@media only screen and (max-width: 768px) {
  .media-query {
    display: none;
  }
}
</style>
